<template>
  <!--  该页面废弃了,因为只有人员变更结果，没有对比-->
  <!--  设计新增的页面为updateZzResult-->
  <div>
    <Return title="更新详情" />
    <div class="bodyControll">
      <a id="qi" class="them">
        <div class="line"></div>
        其他专职专业人员
        <div class="des">
          共：<span class="number">{{ count }}</span
        >人
        </div>
        <div class="des" style="margin-left: 51px">
          高级职称人数：<span class="number">{{ gao }}</span
        >人
        </div>
        <div class="des" style="margin-left: 51px">
          中级职称人数：<span class="number">{{ zhong }}</span
        >人
        </div>
      </a>
      <el-button class="add" type="text" @click="line_add"
      >添加专职人员
      </el-button>
      <AddStaff
        v-if="dialogVisible"
        :add.sync="dialogVisible"
        :tableData.sync="tableData"
        :idx="idx"
        :line_data.sync="line_data"
        :detailShow="detailShow"
        :row="row"
      />
      <el-table :data="tableData" class="tableControll" empty-text="暂无数据">
        <el-table-column
          style="margin-left: 30px"
          type="index"
          label="序号"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="idcard" align="center" label="身份证号">
        </el-table-column>
        <el-table-column
          prop="cert_name"
          align="center"
          label="具备执(从)业资格证书名称"
        >
        </el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <div class="handle">
              <div class="total">
                <el-link
                  class="handle"
                  @click="line_detail(scope.row, scope.$index)"
                >查看详情
                </el-link>
                <el-link
                  v-if="!id"
                  class="handle"
                  @click="line_edit(scope.row, scope.$index)"
                >编辑
                </el-link>
                <el-link
                  v-if="!id"
                  class="handle"
                  @click="line_del(scope.row, scope.$index)"
                >删除
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="btnControll">
        <!--        <div class="saveBtn" @click="saveStaff()">保存</div>-->
        <div class="go" @click="submit()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import Return from "@/components/record/Return";
import AddStaff from "@/components/record/AddStaff";
// import { getStaff } from "@/api/staff.js";
import { mapGetters } from "vuex";
import {
  updateSubmit,
  updateDetail,
  getUpdateData,
  updateNo
} from "@/api/update";

export default {
  name: "createStaff",
  components: {
    AddStaff,
    Return
  },
  data() {
    return {
      type: null, //类型
      record_id: null, // 直接点击变更进来的 一定带record_id
      id: null, //点击查看人员详情/编辑 进来的 一定带id
      status: null, //驳回进来编辑 一定带status和id
      val: 1,
      dialogVisible: false,

      idx: -1,
      line_data: {
        name: "",
        idcard: "",
        idcard_f_image: "",
        idcard_b_image: "",
        major: "",
        phone: "",
        title: "",
        cert_name: "",

        // cert_start_time: "",
        // cert_finish_time: "",

        cert_exp_start_time: "", //注册证书有效期开始
        cert_exp_finish_time: "", //注册证书有效期结束

        // license: "",
        title_image: ""
      }, //当前编辑的行
      detailShow: false, //是否显示详情
      row: {}, //每一行

      list: [], //提交的表单

      tableData: [],
      oldTable: [],

      canSubmit: false //是否能提交变更
    };
  },
  watch: {},
  async created() {
    // 提交 一定要带record_id
    if (this.$route.query.record_id) {
      this.record_id = this.$route.query.record_id;
      // //之前提交过的详情
      // await this.init();
    }
    // 现在是带着不同type进来就行了，后端自己给我分辨是要最新的还是信息登记里面的
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      await this.inits();
    }

    //点击查看人员详情 进来的 一定带id
    if (this.$route.query.id) {
      //点击编辑 或 查看详情进来的
      this.id = this.$route.query.id;
      //没有缓存加载之前提交过的详情
      await this.initZz();
    }

    //驳回点击编辑 人员详情 进来的 一定带id 和 status
    if (this.$route.query.id && this.$route.query.status) {
      //点击编辑 或 查看详情进来的
      this.id = this.$route.query.id;
      this.status = this.$route.query.status;
      //没有缓存加载之前提交过的详情
      await this.getUpNo();
    }
    //一进入页面查看是否有缓存
    // const reTemp = await this.getSave();
    // if (reTemp === false) {

    // } else {
    //   await this.init(false);
    // }
  },
  computed: {
    ...mapGetters(["skk_will_be_year"]),
    // gao: "", //高级
    // zhong: "", //中级
    // count: "", //数量
    //高级人员
    gao() {
      let gaoNumber = 0;
      this.tableData.forEach((el) => {
        if (el.title && el.title.includes("高")) {
          gaoNumber = gaoNumber + 1;
        }
      });
      return gaoNumber;
    },
    //中级人员
    zhong() {
      let zhongNumber = 0;
      this.tableData.forEach((el) => {
        if (el.title && el.title.includes("工程师") && el.title.length === 3) {
          zhongNumber = zhongNumber + 1;
        }
        // if (el.title.includes("工程师") && el.title.length == 3) {
        //   zhongNumber = zhongNumber + 1;
        // }
      });
      return zhongNumber;
    },
    count() {
      return this.tableData.length;
    }
  },
  methods: {
    //一进入页面查看是否有缓存
    // async getSave() {
    //   const res = await getSaveStatus("savestaff");
    //   if (res && res.length > 0) {
    //     // console.log(res, "缓存---------------------》");
    //     this.tableData = res;
    //     return true;
    //   }
    //   return false;
    // },
    //提交
    async submit() {
      let tempData = [];
      let tempImgs = [
        "cert_image",
        "idcard_b_image",
        "idcard_f_image",
        "title_image"
      ];
      let tepVal = "";
      let tepItem = {};
      this.tableData.forEach((item) => {
        tepItem = item;
        tempImgs.forEach((item2) => {
          tepVal = tepItem[item2];
          // TODO 正是站这里没有https(建设厅服务器安装不了https证书)
          if (tepVal) {
            //测试域名
            // tepVal = tepVal.replace(/https:\/\/zjzxadmin.jc881.com(\/+)/g, "/");
            // 正式域名
            tepVal = tepVal.replace(/http:\/\/zjqyadmin.ynbzde.com(\/+)/g, "/");
            tepItem[item2] = tepVal;
          }
        });
        // console.log(tepItem, "<><><>");
        tempData.push(tepItem);
      });
      //如果表单没有被改动，那么提示编辑后才可以提交
      //循环改动的数组和老数组，查出区别

      this.oldTable.forEach((item1, index1) => {
        this.tableData.forEach((item2, index2) => {
          //索引相同
          if (index1 == index2) {
            // console.log("索引相同");
            // console.log(item1, "item1");
            // console.log(item2, "item2");
            //item1为数组里面的每一项（对象）
            for (let i1 in item1) {
              for (let i2 in item2) {
                //如果对象里面的键相同
                if (i1 == i2) {
                  // console.log(i1);
                  // console.log(i2);
                  // 先把所有的和图片相关的字段的值都去掉域名再去对比 是否编辑过
                  if (item1[i1] && tempImgs.includes(i1)) {
                    //正式域名
                    item1[i1] = item1[i1].replace(
                      /http:\/\/zjqyadmin.ynbzde.com(\/+)/g,
                      "/"
                    );
                    //测试域名
                    // item1[i1] = item1[i1].replace(
                    //   /https:\/\/zjzxadmin.jc881.com(\/+)/g,
                    //   "/"
                    // );
                  }
                  if (item2[i2] && tempImgs.includes(i2)) {
                    //正式域名
                    item2[i2] = item2[i2].replace(
                      /http:\/\/zjqyadmin.ynbzde.com(\/+)/g,
                      "/"
                    );
                    //测试域名
                    // item2[i2] = item2[i2].replace(
                    //   /https:\/\/zjzxadmin.jc881.com(\/+)/g,
                    //   "/"
                    // );
                  }
                  //其中一个有值 且两个值不同，用户编辑过,可以提交
                  if ((item1[i1] || item2[i2]) && item1[i1] != item2[i2]) {
                    // console.log(item1[i1], "a");
                    // console.log(item2[i2], "b");
                    this.canSubmit = true;
                  }
                }
              }
            }
          }
        });
      });
      //确定没问题后注释下面两行
      // console.log(this.canSubmit);
      // return false;

      if (this.canSubmit) {
        await updateSubmit({
          data: tempData,
          record_id: this.record_id,
          type: 2
        });
      } else {
        this.$message.error("需要修改后才可以提交!");
        return false;
      }

      //提交的 人员 更新表当
      this.$message.success("提交成功！");
      this.$router.push({ name: "updateIndex" });
    },
    //详情
    line_detail(row, index) {
      this.row = row;
      this.idx = index;
      this.line_data = row;
      this.dialogVisible = true;
      this.detailShow = true;
    },
    //编辑
    line_edit(row, index) {
      this.dialogVisible = true;
      if (row.cert_exp_start_time && row.cert_exp_start_time) {
        row.cert_exp_time =
          row.cert_exp_start_time + "至" + row.cert_exp_finish_time;
      }
      this.line_data = row;
      this.idx = index;
      this.detailShow = false;
    },
    //添加
    line_add() {
      this.dialogVisible = true;
      this.line_data = {};
      this.idx = -1;
    },
    //删除
    line_del(row, index) {
      this.$confirm("确定删除？", {
        type: "warning"
      })
        .then(() => {
          this.tableData.splice(index, 1);
        })
        .catch(() => {
        });
    },
    // 加载准备变更的人员信息 详情
    // async init(form = true) {
    //   const res = await getStaff(this.record_id);
    //   console.log(res, "res---");
    //   if (form) {
    //     this.tableData = res.level0.list;
    //   }
    // },
    async inits() {
      const res = await getUpdateData({ type: this.type });
      if (res) {
        this.tableData = res;
        this.oldTable = JSON.parse(JSON.stringify(res));
      }
    },

    // 加载（已经变更过的） 点击 详情 查看的人员信息
    async initZz() {
      const res = await updateDetail({ id: this.id });
      console.log(typeof res);
      if (res) {
        this.tableData = res;
      }
    },

    //驳回后的编辑详情
    async getUpNo() {
      const res = await updateNo({ id: this.id });
      if (res) {
        this.tableData = res;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bodyControll {
  background: #ffffff;
  border-radius: 2px;
  padding: 30px 20px;
  margin-top: 20px;

  .handle {
    font-size: 12px;
    color: #666666;
    margin-left: 20px;
    text-decoration: unset;

    &:first-child {
      margin-left: unset;
    }

    &:hover {
      color: #4379f6;
    }
  }

  .total {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .steps {
    border-bottom: 1px solid #dddddd;
    padding: 0 149px 24px;
  }

  .mao {
    display: flex;
    align-items: center;
    margin-top: 30px;

    .it {
      padding: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      cursor: pointer;
      border: 1px solid #dddddd;
      color: #666666;
      text-decoration: unset;
    }

    .active {
      background: #e4ecff;
      border: 1px solid #4379f6;
      text-align: center;
      color: #4379f6;
    }
  }

  .them {
    display: flex;
    align-items: center;
    position: relative;
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    padding-left: 15px;

    .line {
      width: 4px;
      height: 16px;
      background: #4379f6;
      left: 0px;
      position: absolute;
    }

    .des {
      font-size: 14px;
      color: #666666;
      margin-left: 20px;
      font-weight: 400;

      .number {
        font-size: 16px;
        font-family: "BEBAS";
        color: #333333;
        font-weight: 700;
        margin-right: 5px;
      }
    }
  }

  .add {
    width: 100px;
    height: 32px;
    background: #4379f6;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    margin-top: 18px;
  }

  .tableControll {
    width: 100%;
    border: solid 1px rgb(235, 238, 245);
    border-bottom: unset;
    margin-top: 18px;
  }

  /deep/ .el-table th {
    background: #f6f6f6 !important;
    color: #666;
    font-weight: normal;
  }

  /deep/ .el-table tr {
    color: #333 !important;
    font-size: 12px;
  }

  /deep/ .el-table__empty-text {
    line-height: unset;
  }

  .btnControll {
    display: flex;
    align-items: center;

    div {
      margin-top: 40px;
      width: 100px;
      height: 38px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .saveBtn {
      background: #d7ddeb;
      color: #333;
    }

    .go {
      background: #f39020;
      color: #fff;
    }
  }
}
</style>
